import { LDFlagSet } from 'launchdarkly-react-client-sdk';

// Should be a camelcase version of the key in the LD console
export enum LDFeatureFlagEnum {
  RELEASE_UNDO_MAPPING = 'releaseUndoMapping',
  SHOW_FUTURE_OPERATIONS_CHECKBOX = 'showFutureOperationsCheckbox',
  SHOW_NO_FIELD_MATCH_CHECKBOX = 'showNoFieldMatchCheckbox',
  SHOW_OPERATION_TYPE_FILTER = 'showOperationTypeFilter',
  SHOW_UNMAPPED_OPERATION_COUNT = 'showUnmappedOperationCount',
  ENABLE_MATCHING_HISTORY_IGNORED_FILTER = 'enabledMatchingHistoryIgnoredFilter',
  ENABLE_FIELD_MATCHING_PAGE = 'enableFieldMatchingPage',
  ENABLE_AMPLITUDE_GUIDES = 'enableAmplitudeGuides',
  ENABLE_V3_AUTH = 'enableV3AuthFromFrontend',

  // Permanent FFs
  SHOW_MFE_DEMO_PAGE = 'databusShowMfeDemoPage',

  // Field Matching Submit Options FF
  ENABLE_CREATE_NEW_FIELD = 'fieldMatchingCreateNewField',
  ENABLE_SAVE_TO_A_FIELD = 'fieldMatchingSaveToAField',
  ENABLE_EXPAND_TO_THE_FIELD_SHAPE = 'fieldMatchingExpandFieldShape',
  ENABLE_IGNORE_OPERATION_DATA = 'fieldMatchingIgnoreMatch',
  ENABLE_MACHINERY_FIELD_OPERATIONS = 'fieldMatchingMachineryFieldOperations',
}
type LDFeatureFlagSettings = {
  [key in LDFeatureFlagEnum]: boolean;
};

export const evaluateBooleanFeatureFlag = (flags: LDFlagSet, flag: LDFeatureFlagEnum): boolean => {
  return Object.keys(flags).includes(flag) ? flags[flag] : false;
};

export const getBooleanFeatureFlagValues = (flagSet: LDFlagSet): LDFeatureFlagSettings =>
  Object.fromEntries(
    Object.values(LDFeatureFlagEnum).map((flag) => [
      flag,
      evaluateBooleanFeatureFlag(flagSet, flag),
    ]),
  ) as LDFeatureFlagSettings;
